var _linearGradient, _path, _path2, _path3, _use, _use2, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebkit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#fff",
    viewBox: "0 0 5940 5940",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#34aadc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#007aff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M2354 4728L738 3458a611 611 0 01-253-480c0-180 90-352 253-480l1616-1272a1003 1003 0 01616-199c233 0 450 72 616 200l1616 1270a611 611 0 01253 480c0 182-90 353-253 480L3586 4727a996 996 0 01-616 201c-233 0-450-70-616-200z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M2354 3928L738 2658a611 611 0 01-253-480c0-180 90-352 253-480L2354 426a1003 1003 0 01616-199c233 0 450 72 616 200l1616 1270a611 611 0 01253 480c0 182-90 353-253 480L3586 3927a996 996 0 01-616 201c-233 0-450-70-616-200z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9d00",
    d: "M5200 3280a590 590 0 010 973L3590 5517a1060 1060 0 01-1240 0L740 4255a590 590 0 011-974l1610-1264c342-266 898-266 1240 0l1609 1263z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#fc0",
    xlinkHref: "#a"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2976 3395c825 0 1494-547 1494-1222 0-673-670-1223-1494-1223-826 0-1496 550-1496 1223 0 675 670 1222 1495 1222zm0 126c-910 0-1650-603-1650-1348 0-744 740-1347 1650-1347s1648 604 1648 1347c0 745-738 1348-1648 1348z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#8cc8f6",
    d: "M3086 2692c82-10 163-34 237-70l470 194-246-370a430 430 0 000-546l246-370-443 183-13 195a330 330 0 01-12 538 514 514 0 01-160 85l-80 160zm-220-1036c-137 18-240 70-240 70l-470-194 246 370a431 431 0 000 545l-246 370 454-187 10-183a330 330 0 013-546c45-40 146-82 160-85l80-160z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2750 2133l-63 1110 507-1030 72-1107-516 1027zm-7 897l406-824-356-65-50 890z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebkit);
export default __webpack_public_path__ + "static/media/webkit.e5ba2ed6bb9c15c99acc3840bc476f48.svg";
export { ForwardRef as ReactComponent };